import { FC, useMemo } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/coaching/advisorLandingPage/IncomeSection/IncomeSection.styl'
import Button from 'components/features/pfm/Button/Button'
import { maskCurrencyFromZero } from 'components/atoms/inputs/maskedInput'
import { FutureInput } from 'components/atoms/inputs/FutureInput/FutureInput'
import { MaskedInputController } from 'components/atoms/inputs/maskedInput/MaskedInput/MaskedInput'
import { ThemeProvider } from 'components/features/theme/ThemeProvider/ThemeProvider'
import { useForm, FormProvider } from 'react-hook-form'
import { InputStateTheme } from 'components/atoms/inputs/InputStateTheme/InputStateTheme'
import { FutureInputDecorationLabel } from 'components/features/future/FutureInputDecoration/FutureInputDecorationLabel'
import * as yup from 'yup'
import { schemaNumber } from 'schemas/baseSchema'
import { yupResolver } from '@hookform/resolvers/yup'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'

const schema = yup.object({
  income: schemaNumber.notRequired(),
})
type IncomeSectionProps = {
  onCTA: (income?: number) => void
}
const IncomeSection: FC<IncomeSectionProps> = (props) => {
  const { onCTA } = props

  const formContext = useForm<{ income?: number }>({
    resolver: yupResolver(schema),
  })
  const { handleSubmit } = formContext
  const handleSuccessSubmit = useMemo(() => handleSubmit(({ income }) => {
    onCTA(income)
  }), [handleSubmit, onCTA])

  return (
    <section className={ cn(styles.incomeSection) }>
      <div className={ styles.content }>
        <div className={ styles.img }>
          <img src='/images/coaching/focus.png' width='100%' />
        </div>
        <FormProvider { ...formContext }>
          <form onSubmit={ handleSuccessSubmit } className={ styles.incomeForm }>
            <h4>Ready to schedule your session?</h4>
            <p>Enter your annual income to help us find you the right coach.</p>

            <div className={ styles.inputWrapper }>
              <ThemeProvider futureFieldTitle='regular'>
                <InputStateTheme>
                  <FutureInputDecorationLabel className={ styles.label }>
                    Your Annual Income
                  </FutureInputDecorationLabel>
                  <MaskedInputController
                    className={ styles.input }
                    options={ maskCurrencyFromZero }
                    name='income'
                    inputMode='numeric'
                    renderer={ FutureInput }
                    autoComplete='off'
                  />
                </InputStateTheme>
              </ThemeProvider>
            </div>
            <div className={ styles.submit }>
              <AnalyticsClick
                category='page_controls-coaching_landing'
                action='click-schedule_cta'
                label='income_section'
              >
                <Button fullWidth text='Find a coach for me' submit />
              </AnalyticsClick>
            </div>
          </form>
        </FormProvider>
      </div>
    </section>
  )
}

export default IncomeSection
